import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@/features/Table";
import { type S2DataUpload, useS2DataUploadColumns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterS2DataUploadSchema, S2DataUploadFilter } from "./filter";
import { S2DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const S2DataUploadTable = () => {
  const { t } = useTranslation();
  const columns = useS2DataUploadColumns();
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = searchParams.get("client") || "s2";
  const table_name = "s2_data_upload";

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, table_name, "get"],
    });
  };

  return (
    <Table<S2DataUpload, FilterS2DataUploadSchema>
      label={t("data_upload.title")}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<S2DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <S2DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
